// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__tQI+9","table":"styles_table__4ayiz","tooltipChild":"styles_tooltipChild__xZMmf"};